<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'cogs']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('global.notification_settings') }}
        </span>
      </div>
    </template>

    <template #cta>
      <div class="flex justify-end">
        <BaseButton
          v-if="$can('manage_settings')"
          :isElevated="true"
          icon="paper-plane"
          @click="submitNotificationSettings"
          :title="
            $t('button.save_plural', {
              var: $t('global.notification_settings')
            })
          "
        />
      </div>
    </template>

    <template #body v-if="notificationSettings">
      <div class="flex flex-col gap-4">
        <SingleNotificationSettingComponent
          v-for="(setting, index) in metadata"
          :setting="setting"
          :key="index"
          :index="index"
          :notificationSettings="notificationSettings"
        />
      </div>

      <!--      <div class='flex justify-end mt-12 mx-12'>-->
      <!--        <BaseButton v-if="$can('manage_settings')" :isElevated='true' icon='paper-plane' @click='submitNotificationSettings'-->
      <!--                    :title="$t('button.save_plural', {var: $t('global.notification_settings')})"/>-->
      <!--      </div>-->
    </template>
  </SettingsPageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import SingleNotificationSettingComponent from './components/SingleNotificationSettingComponent'

export default {
  name: 'TheNotificationSettingsIndexPage',
  components: {
    SingleNotificationSettingComponent
  },
  computed: {
    ...mapGetters({
      metadata: 'notificationSettings/getNotificationMetadata',
      notificationSettings: 'notificationSettings/getNotificationSettingsList'
    })
  },
  methods: {
    ...mapActions({
      fetchNotificationList: 'notificationSettings/fetchNotificationList',
      updateNotificationsSettings:
        'notificationSettings/updateNotificationsSettings'
    }),
    submitNotificationSettings() {
      this.updateNotificationsSettings({
        notificationSettings: this.notificationSettings
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.updated_plurals', {
            var: this.$t('global.notification_settings')
          })
        )
      })
    }
  },
  async mounted() {
    await this.fetchNotificationList()
  }
}
</script>
